
<div class="row">
    <div *ngFor="let pd of service.pageOfItems" class="col-4  mb-3">
        <div class="ps-post mb-30">
        <div class="ps-post__thumbnail">
            <a class="ps-post__overlay" [routerLink]="['post', pd.slug]"></a>
            <img  class="img-fluid"  src="{{pd.image}}"  style="width:810px;height:150px;" alt=""></div>
        <div class="ps-post__content">
            <a class="ps-post__title" [routerLink]="['post', pd.slug]">
                {{pd.title}}</a>
            <p><i class="fas fa-comment-alt"></i> {{pd.commentCount}} / <i class="fas fa-eye"></i> {{pd.viewCount}} </p>
            <p class="ps-post__meta">
                <span>By:<a class="mr-5" target="_blank"
                     href="https://duylanle-portfolio.netlify.app/">Duy Lan Le</a>
                </span> -<span class="ml-5"> {{pd.createDate}} </span></p>
            <p></p>
            <p>{{pd.abstract}}
                </p><a type='button' class="ps-morelink pointer" 
                [routerLink]="['post', pd.slug]" >Read more<i class="fa fa-long-arrow-right"></i></a>
        </div>
        </div>
    </div>

</div>
    
<div class="mt-5">
    <div class="row">
        <div class="col-6"></div>
        <div class="col text-center">
            <jw-pagination [items]="service.listPosts" (changePage)="service.onChangePage($event)"></jw-pagination>
        </div>
    </div>
</div>
   
